export default "__VITE_ASSET__BJ34VADL__"